import api from "./api";

const KEY = "tdfms_offline_queue";
const notifyChange = () => window.dispatchEvent(new Event("offline-queue-change"));

export const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const setQueue = (q) => {
  localStorage.setItem(KEY, JSON.stringify(q));
  notifyChange();
};

export function enqueue(url, body, label) {
  const q = getQueue();
  q.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, url, body, label, created_at: new Date().toISOString() });
  try { setQueue(q); return true; } catch { return false; }
}

let flushing = false;
export async function flush() {
  if (flushing) return { synced: 0, rejected: 0 };
  flushing = true;
  let synced = 0, rejected = 0;
  try {
    for (const item of getQueue()) {
      try {
        await api.post(item.url, item.body);
        setQueue(getQueue().filter((x) => x.id !== item.id));
        synced++;
      } catch (e) {
        if (e.response && e.response.status !== 401) {
          setQueue(getQueue().filter((x) => x.id !== item.id));
          rejected++;
        } else break; // still offline (or auth issue) — retry later
      }
    }
  } finally { flushing = false; }
  return { synced, rejected };
}

export async function postOrQueue(url, body, label) {
  try {
    const { data } = await api.post(url, body);
    return { data, queued: false };
  } catch (e) {
    if (!e.response && enqueue(url, body, label)) return { queued: true };
    throw e;
  }
}
